import { useMemo } from 'react';
import { memoize } from 'lodash-es';

import { useLocation } from 'ha/helpers/router';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { useOptionalHermes } from 'ha/modules/Hermes';
import { HermesData, PromotedBlogContent } from '../../types';

interface SearchResultsContentCardHook {
  isContentCardAvailable: boolean;
  contentCard: PromotedBlogContent | null;
}

const getRandomInt = memoize((max: number) =>
  Math.floor(Math.random() * Math.floor(max)),
);

const useSearchResultsContentCard = (
  resultsCount: number,
): SearchResultsContentCardHook => {
  const { searchContentCard } = useFeatureFlags();
  const location = useLocation();
  const { page = '1' } = location.query;

  const { data } = useOptionalHermes<HermesData>();

  const contentCard = useMemo(() => {
    if (!data?.promotedContent || data.promotedContent.length <= 0) {
      return null;
    }

    const randomContentIndex = getRandomInt(data.promotedContent.length);

    return data.promotedContent[randomContentIndex];
  }, [data?.promotedContent]);

  const isContentCardAvailable = useMemo(
    () =>
      searchContentCard === 'on' &&
      !!contentCard &&
      resultsCount >= 3 &&
      page === '1',
    [searchContentCard, contentCard, resultsCount, page],
  );

  return {
    isContentCardAvailable,
    contentCard,
  };
};

export default useSearchResultsContentCard;
